import { compose, withProps } from "recompose";

import { withMe } from "../../hoc/repository";
import { IWithMe } from "../../hoc/repository/withMe/withMe";

import { Banner, IProps } from "./Banner";

export type IConnectedProps = IWithMe;
type IContainerProps = Omit<IProps, keyof IConnectedProps>;

export default compose<IProps, IContainerProps>(
  withMe,
  withProps(
    // add groupId and segmentIds to props
    (props: IConnectedProps): { groupId: number; segmentIds: number[] } => {
      const { groupId = 0, segmentIds = [] } = (props && props.me) || {};

      return { groupId, segmentIds };
    }
  )
)(Banner);
